import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TranslocoDirective } from '@jsverse/transloco';
import { Languages } from './shared/components/languages/languages';
import { SchemeToggle } from './shared/components/scheme-toggle/scheme-toggle';

@Component({
  selector: 'app-root',
  templateUrl: './app.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterOutlet, TranslocoDirective, Languages, SchemeToggle],
})
export class App {}
